export const environment = {
  production: false,
  apiBaseUrl: 'https://api.tripgoapp.com'
  //apiBaseUrl: 'https://api.staggin.tripgoapp.com' //pronto despliegue de pruebas
  //apiBaseUrl: 'http://localhost:8080'
};  